<template><rect width="4" height="20" rx="1" fill="#DBDDE1" /></template>
